import { Button, ExpansionPanel, ExpansionPanelActions, ExpansionPanelDetails, ExpansionPanelSummary, Theme, Typography, WithStyles, createStyles, withStyles } from "@material-ui/core";
import React, { ChangeEvent, Component } from "react";
import { faCheck, faChevronDown, faCircle } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from 'prop-types';

const styles = (theme: Theme) => createStyles({
  heading: {
    marginLeft: theme.spacing(1),
  },
  authHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  body: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  error: {
    color: theme.palette.error.dark
  }
})

class GenericEnroll extends Component<GenericEnrollProps, { enrolled: boolean }> {
  static propTypes = {
    expanded: PropTypes.bool.isRequired,
    setExpanded: PropTypes.func.isRequired,
  }

  handleChange = (event: ChangeEvent<{}>, expanded: boolean) =>
    this.props.setExpanded(expanded)

  render() {
    const { expanded, authMethodName, renderForm, handleCancel, handleSave, classes, error, saveDisabled } = this.props

    return (
      <ExpansionPanel expanded={expanded} onChange={this.handleChange}>
        <ExpansionPanelSummary expandIcon={<FontAwesomeIcon icon={faChevronDown} fixedWidth />}>
          <div className={classes.authHeader}>
            {this.props.enrolled ?
              <FontAwesomeIcon icon={faCheck} style={{ color: '#00CC00' }} size="xs" />
              : <FontAwesomeIcon icon={faCircle} style={{ color: '#CCC' }} size="xs" />
            }

            <Typography className={classes.heading}>{authMethodName}</Typography>
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.body}>
          {renderForm()}
        </ExpansionPanelDetails>
        <ExpansionPanelActions>
          {error &&
            <Typography className={classes.error}>{error}</Typography>
          }
          {handleCancel &&
            <Button size="small" onClick={handleCancel}>Cancel</Button>
          }
          {handleSave &&
            <Button size="small" color="primary" onClick={handleSave} disabled={saveDisabled || false}>Save</Button>
          }
        </ExpansionPanelActions>
      </ExpansionPanel>
    )
  }
}

interface GenericEnrollProps extends WithStyles<typeof styles> {
  expanded: boolean
  enrolled: boolean
  setExpanded: (expanded: boolean) => void
  authMethodName: string
  renderForm: () => JSX.Element
  handleCancel?: () => void
  handleSave?: () => void
  saveDisabled?: boolean
  error: string
  dirty: boolean
}

export default withStyles(styles)(GenericEnroll)